import React from "react";
import RebetLoader from "../RebetLoader/RebetLoader";

import "./stylesSaveButton.css";

function SaveButton({
  isApiRunning,
  callbackFunction,
  buttonText = "Save",
  cancelButton = false,
  cancelButtonText = "",
  callbackFunctionCancel = null,
}) {
  return (
    <div
      className="save-buttons-container"
      style={
        !cancelButton
          ? { justifyContent: "center" }
          : { justifyContent: "space-between" }
      }
    >
      {cancelButton && (
        <button
          className="cancel-button"
          onClick={callbackFunctionCancel}
          disabled={isApiRunning}
        >
          {cancelButtonText}
        </button>
      )}
      <button
        className={`save-button ${isApiRunning ? "saving" : ""}`}
        disabled={isApiRunning}
        onClick={callbackFunction}
      >
        {isApiRunning ? (
          <RebetLoader height={"20px"} width={"20px"} />
        ) : (
          buttonText
        )}
      </button>
    </div>
  );
}

export default SaveButton;
